module.exports = __webpack_public_path__ + "img/facebook_logo.38768b29.svg";